<template>
  <div
    class="nio-option-box"
    :class="{
      checked: checked,
      disabled: disabled,
    }"
    @click.stop="handleClick"
  >
    <div class="nio-option-box__content">
      <nio-icon
        :type="checked ? 'check' : 'add'"
        class="nio-option-box__icon"
      />

      <span class="nio-option-box__text">
        {{ checked ? checkedLabel : uncheckedLabel }}
      </span>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  checked: [Boolean, Number],
  disabled: [Boolean, Number],
  checkedLabel: {
    type: String,
    default: '已选装',
  },
  uncheckedLabel: {
    type: String,
    default: '添加选装',
  },
})

const emits = defineEmits(['update:checked', 'click'])

const handleClick = () => {
  if (!props.disabled) {
    emits('click')
    emits('update:checked', !props.checked)
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';

.nio-option-box {
  @include flex-center;
  @include transition;
  width: rem(75);
  height: rem(25);
  border: 1px solid $color-text-primary;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
  background-color: transparent;

  // 选中状态
  &.checked {
    border-color: $color-divider-default;
  }

  // 禁用状态
  &.disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &__content {
    @include flex-center;
    color: inherit;
  }

  &__icon {
    width: rem(14);
    height: rem(14);
    color: inherit;
  }

  &__text {
    margin-left: rem(2);
    font-size: rem(10);
    font-weight: 400;
    line-height: 1.5;
    white-space: nowrap;
  }

  .nio-dark & {
    color: #ffffff;
    border-color: #ffffff;

    &.checked {
      border-color: rgba($color: #ffffff, $alpha: 0.2);
    }
  }
}
</style>
